"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = void 0;
function isString(item) {
    return typeof item === 'string';
}
exports.isString = isString;
